module.exports = __webpack_public_path__ + "static/scheme@2x-d6da997499d3ff2b9de6104c3d086c1c.png";